import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, ElementRef, Input, OnDestroy, Optional, Self} from '@angular/core';
import {FormBuilder, FormGroup, ControlValueAccessor, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import {FormControl} from '@angular/forms';
import {debounceTime, switchMap, tap} from 'rxjs/operators';
import { User } from '../../shared/models/user';
import { Collaborateur } from '../../shared/models/collaborateur';
/** Custom `MatFormFieldControl` for telephone number list. */
@Component({
  selector: 'app-user-list',
  templateUrl: 'user-list.component.html',
  styleUrls: ['user-list.component.scss'],
   providers: [        
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UserListComponent,
            multi: true,
        }
    ]  

})
export class UserListComponent implements ControlValueAccessor {

	@Input() placeholder: string;
	@Input() errors: string;

	stateCtrl = new FormControl();
	users: User[] = [];
	allUsers: User[] = [];
	selected: Collaborateur[] = [];

	constructor(
      private userService: UserService
	) { 
  	}
 
  	propagateChange = (_: any) => {};
  	
  	ngOnInit() {      
  		this.userService.getAll('name',2,{},0,20).subscribe(t => {
          this.allUsers =t.body;

          this.users = this.allUsers.filter(u => this.selected.findIndex(uu => uu.user.id === u.id));
       });  

  	}
 
 	remove(u) {
 		this.selected = this.selected.filter(us => us.user.id !== u.user.id);
 		this.users.push(u.user);
 		this.propagateChange(this.selected);  			
 	}
  	onChange(event) {
  		let us = this.users.find(u => u.id === event.value);
  		if (us) {
	  		this.selected.push(Object.assign(new Collaborateur,{user:us}));
	  		this.users = this.users.filter(u => u.id !== event.value);
	  		this.propagateChange(this.selected);  			
  		}
  	}

    writeValue(obj: any): void {  
      this.selected = obj ? obj : [];      
      console.log('writeValue' , obj);
    	//this.stateCtrl.patchValue(obj.id);    
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState?(isDisabled: boolean): void { }
}